export default __webpack_public_path__ + "static/media/49ers.e2d581c2.jpg";